<template>
  <symbol
    id="three-dots"
    viewBox="0 0 16 16"
    fill="currentColor"
  >
    <g
      id="SVGRepo_bgCarrier"
      stroke-width="0"
    /><g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    /><g id="SVGRepo_iconCarrier">
      <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
    </g>
  </symbol>
</template>
